/* VELTRA analytics — GA4 (G-ZGBHV50P02) + 预留 Meta Pixel
   事件：page_view / view_item / add_to_cart / begin_checkout / purchase
   全部 try/catch 包裹，任何取不到对象都不影响页面。 */
(function () {
  var GA4_ID = 'G-ZGBHV50P02';
  var META_PIXEL_ID = '1594712988444487';

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;

  // 真正把 gtag.js 拉进来（只 push dataLayer 不发请求）
  (function () {
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID;
    document.head.appendChild(s);
  })();

  gtag('js', new Date());
  gtag('config', GA4_ID, { send_page_view: true });

  if (META_PIXEL_ID) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }

  function money(v) { return typeof v === 'number' ? v / 100 : parseFloat(v || 0); }
  function meta() { try { return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {}; } catch (e) { return {}; } }

  // ---- view_item（商品页）----
  function trackViewItem() {
    try {
      if (!/\/products\//.test(location.pathname)) return;
      var m = meta();
      var p = m.product;
      if (!p) return;
      var variant = (p.variants && p.variants[0]) || {};
      var item = {
        item_id: String(p.id),
        item_name: p.title || document.title,
        item_brand: 'VELTRA',
        item_category: (p.type || 'Footwear'),
        price: money(variant.price),
        currency: (m.currency || 'EUR'),
        quantity: 1,
      };
      gtag('event', 'view_item', { currency: item.currency, value: item.price, items: [item] });
      if (window.fbq) window.fbq('track', 'ViewContent', { content_ids: [item.item_id], content_type: 'product', value: item.price, currency: item.currency });
    } catch (e) {}
  }

  // ---- add_to_cart（拦截 /cart/add 请求 + 表单提交）----
  function trackAddToCart(price, name, variantId, currency) {
    try {
      var value = money(price);
      gtag('event', 'add_to_cart', {
        currency: currency || 'EUR',
        value: value,
        items: [{ item_id: String(variantId || ''), item_name: name || 'VELTRA item', item_brand: 'VELTRA', price: value, quantity: 1 }],
      });
      if (window.fbq) window.fbq('track', 'AddToCart', { content_ids: [String(variantId || '')], content_type: 'product', value: value, currency: currency || 'EUR' });
    } catch (e) {}
  }

  function hookFetch() {
    if (!window.fetch || window.__veltraFetchHooked) return;
    window.__veltraFetchHooked = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/add/.test(url)) {
        p.then(function (r) {
          if (!r.ok) return;
          try {
            var m = meta();
            var pr = m.product;
            var v = pr && pr.variants && pr.variants[0];
            trackAddToCart(v ? v.price : 0, pr ? pr.title : '', v ? v.id : '', m.currency);
          } catch (e) {}
        }).catch(function () {});
      }
      return p;
    };
  }

  // ---- purchase（订单完成页）----
  function trackPurchase() {
    try {
      if (!/\/checkout\/thank_you|\/orders\//.test(location.pathname)) return;
      var co = window.Shopify && window.Shopify.checkout;
      if (!co) return;
      var value = money(co.subtotal_price || co.total_price || 0);
      var items = (co.line_items || []).map(function (li) {
        return { item_id: String(li.variant_id || li.id || ''), item_name: li.title, price: money(li.price), quantity: li.quantity };
      });
      var currency = co.currency || 'EUR';
      gtag('event', 'purchase', { transaction_id: String(co.order_id || ''), currency: currency, value: value, items: items });
      if (window.fbq) window.fbq('track', 'Purchase', { value: value, currency: currency, content_ids: items.map(function (i) { return i.item_id; }), content_type: 'product' });
    } catch (e) {}
  }


  // ---- Organization 结构化数据（补 address / telephone / email）----
  (function () {
    if (document.querySelector('script[data-veltra-org]')) return;
    var data = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Royal Hearth LLC',
      alternateName: 'VELTRA',
      url: location.origin,
      email: 'support@veltra-shoes.com',
      telephone: '+1-413-489-9222',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '2700 E Colfax Ave',
        addressLocality: 'Denver',
        addressRegion: 'CO',
        postalCode: '80206',
        addressCountry: 'US'
      },
      identifier: 'Colorado entity ID 20261660783'
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.setAttribute('data-veltra-org', '1');
    s.textContent = JSON.stringify(data);
    document.head.appendChild(s);
  })();

  function run() {
    trackViewItem();
    trackPurchase();
    hookFetch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
